import {
  debugRequestLogger,
  debugResponseLogger,
  errorResponseLogger
} from "./apilogger";

import _ from "lodash";
import axios from "axios";
import humps from "humps";

const CreditReportModelsNumbers = Object.freeze({
  VantageScore: 'creditReport05402',
  FicoScore: 'creditReport05206',
  ResidentScore: 'creditReport00A72'
});

function create(apiHost, config) {
  const { debug, chaos, ...rest } = config || {};
  const instance = axios.create({
    baseURL: apiHost,
    timeout: 60000,
    withCredentials: true,
    transformResponse: [
      ...axios.defaults.transformResponse,
      (data) => humps.camelizeKeys(data)
    ],
    transformRequest: [
      (data) => {
        if (data instanceof FormData) {
          let formData = new FormData();
          for (const [key, value] of data.entries())
            formData.append(humps.decamelize(key), value);

          return formData;
        }

        return humps.decamelizeKeys(data, (key, convert, options) => {
          // converts creditReport05206 to credit_report_05206 instead of credit_report05206
          // converts creditReport00A72 to credit_report_00A72 (keep A72 as one unit)
          const fixRegistry = [CreditReportModelsNumbers.FicoScore, CreditReportModelsNumbers.VantageScore, CreditReportModelsNumbers.ResidentScore];
          if (fixRegistry.includes(key)) {
            if (key === CreditReportModelsNumbers.ResidentScore) {
              return "credit_report_00A72";
            }
            return convert(key, { ...options, split: /(?=[A-Z])|(?<=[a-z])(?=\d)/ });
          }
          return convert(key, options);
        });
      },
      ...axios.defaults.transformRequest
    ],
    ...rest
  });
  if (debug) {
    console.log(
      "apiBase: Debug mode enabled, setting up Axios logging for calls to",
      apiHost
    );
    instance.interceptors.request.use(...debugRequestLogger);
    instance.interceptors.response.use(...debugResponseLogger);
  } else instance.interceptors.response.use(...errorResponseLogger);

  if (chaos) {
    console.log(
      "apiBase: Chaos mode enabled, adding random delays to api calls"
    );
    instance.interceptors.request.use(requestChaos);
  }
  return instance;
}

function requestChaos(config) {
  // Add some delay into api calls to simulate real-world behavior.
  let debugDelay = 250 + Math.random() * 1000;
  // Add some p90 and p95 latencies
  const percentile = Math.random();
  if (percentile < 0.05) debugDelay += 3000 + Math.random() * 4000;
  else if (percentile < 0.1) debugDelay += 1000 + Math.random() * 2000;

  return Promise.resolve(config).delay(debugDelay);
}

function handleStatus(status, cb) {
  return (error) => {
    if (_.get(error, "response.data.error.status") === status) return cb(error);

    throw error;
  };
}

function mergeParams(params, o) {
  const cased = humps.decamelizeKeys(params || {});
  return { params: cased, ...o };
}

export default {
  create,
  handleStatus,
  mergeParams,
  pick: (s) => (o) => _.get(o, s),
  pickData: (o) => o.data,
  swallow: (status) => handleStatus(status, _.noop)
};
